import { useEffect } from 'react';
import { makeVar, useReactiveVar } from '@apollo/client';

export interface filtersState {
  [id: string]: { isSelected: boolean; filterGroupName: string };
}

export const filtersStateVar = makeVar<filtersState>({});

export const updateFilterSelection = (
  filterId: number,
  newValue: boolean,
  filterGroupName: string,
  filterLabel?: string
) => {
  filtersStateVar({
    ...filtersStateVar(),
    [filterId]: { isSelected: newValue, filterGroupName: filterGroupName },
  });

  // for GA event
  if (newValue && filterLabel) {
    //@ts-ignore
    window?.dataLayer.push({
      text: filterLabel,
      event: 'filter_apply',
    });
  } else if (filterLabel) {
    //@ts-ignore
    window?.dataLayer.push({
      text: filterLabel,
      event: 'filter_remove',
    });
  }
};

export const usePersistentFilterSelection = () => {
  const filterSelectState = useReactiveVar(filtersStateVar);

  return filterSelectState;
};
